// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './plugins/axios';
import 'core-js';

import Vue from 'vue';
import App from './App';
import {router} from './plugins/router';
import ElementUI from './plugins/element';
import VueSidebarMenu from './plugins/sidebar';
import vueDragAndDropList from 'vue-drag-and-drop-list';
import Firebase from './plugins/firebase';
import {store} from './store/store';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import locale from 'element-ui/lib/locale/lang/ru-RU';
import 'vue-select/dist/vue-select.css';
import firebase from 'firebase';
import {Notification} from 'element-ui'
import {getDemoUser} from './firestore/demo';
import dayjs from "dayjs";

var utc = require('dayjs/plugin/utc')
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false;
Vue.use(VueSidebarMenu);
Vue.use(Firebase);
Vue.use(vueDragAndDropList);
Vue.use(ElementUI, {locale});
Vue.use(VueClipboard)

dayjs.extend(utc)



const initApp = () => {
  Firebase.auth().onAuthStateChanged(() => {
    new Vue({
      el: '#app',
      store: store,
      router: router,
      render: h => h(App),
    });


    if (!firebase.auth().currentUser) {
      localStorage.removeItem('company');
    }

    setTimeout(async () => {
      const token = sessionStorage.getItem('invite_token');
      const projectId = sessionStorage.getItem('invite_project');
      let flag = true;
      if (firebase.auth().currentUser && token && projectId) {
        const path = firebase.firestore().collection('invites');
        path
          .where('hash', '==', token)
          .where('projectId', '==', projectId)
          .get()
          .then((data) => {
            if (data.size > 0) {
              data.forEach((subDoc) => {
                if (flag) {
                  flag = false;
                  const subDocData = subDoc.data();
                  if (subDocData.email.toLowerCase() !== firebase.auth().currentUser.email.toLowerCase()) {

                    if (!localStorage.getItem('notify')) {
                      Notification({
                        offset: 60,
                        title: 'Ошибка',
                        message: 'Приглашение не принято, пожалуйста попробуйте выполнить вход с почты на которую было выслано приглашение',
                        type: 'error',
                      });
                      localStorage.setItem('notify', true);
                      firebase.auth().signOut().then(() => {
                        router.push('/');
                      });
                    }
                    return false;
                  } else {

                    firebase.firestore().collection('projects').doc(projectId).get().then((response) => {
                      const responseData = response.data();
                      if (!responseData) return;
                      if (responseData.rules[firebase.auth().currentUser.uid]) {
                        return false;
                      }
                      firebase.firestore()
                        .collection('projects')
                        .doc(projectId)
                        .collection('users')
                        .where(
                          'email',
                          '==',
                          firebase.auth().currentUser.email,
                        ).get().then((user) => {
                        if (user.size === 0) {
                          firebase.firestore().collection('projects').doc(projectId).update(
                            {
                              ...responseData,
                              rules: {
                                ...responseData.rules,
                                [firebase.auth().currentUser.uid]: subDocData.rules,
                              },
                            },
                          ).then(async () => {
                            await firebase.firestore().collection('invites').doc(subDoc.id).delete();

                            let user_register = await getDemoUser(firebase.auth().currentUser.uid);

                            await firebase.firestore()
                              .collection('projects')
                              .doc(projectId)
                              .collection('users')
                              .add({
                                uid: firebase.auth().currentUser.uid,
                                position: '',
                                name: user_register.name,
                                email: firebase.auth().currentUser.email,
                                phone: user_register.phone,
                                company: user_register.company,
                                role: subDocData.rules,
                                isInvited: true,
                              });
                            localStorage.removeItem('user-register');
                            Notification({
                              offset: 60,
                              title: 'Успешно',
                              message: 'Приглашение принято!',
                              type: 'success',
                            });
                            setTimeout(() => {
                              localStorage.removeItem('invite_token');
                              localStorage.removeItem('invite_project');
                              setTimeout(() => {
                                location.reload();
                              }, 1000);
                            }, 1000);
                          });
                        }
                      });
                    });
                  }
                }
              });
            }
          }).catch((e) => {
          console.error(e);
        });
      } else if (!firebase.auth().currentUser && token && projectId) {
        Notification({
          offset: 60,
          title: 'Необходимо авторизоваться',
          message: 'Для того чтоб принять приглашение необходимо выполнить авторизацию',
          type: 'warning',
        });
      }
    }, 0);
  });
}

initApp();

document.getElementById('reload').onclick = initApp



// WEBPACK FOOTER //
// ./src/main.js